import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { getSelectedNavigationLinkIdForPath } from './navigation-header-routes';

export const useNotifyNavigationHeader = () => {
  const location = useLocation();

  useEffect(() => {
    const routeChangeEvent = new CustomEvent(
      '__custom-event__client-route-change',
    );
    document.dispatchEvent(routeChangeEvent);

    // Attempt to highlight the current tab
    dispatchMakeActiveEvent(location.pathname);
  }, [location.pathname]);
};

export const dispatchInitialiseEvent = () => {
  const initialiseEvent = new CustomEvent('__custom-event__initialise');
  document.dispatchEvent(initialiseEvent);
};

export const dispatchMakeActiveEvent = (currentPath: string) => {
  const activeLinkId = getSelectedNavigationLinkIdForPath(currentPath);

  if (activeLinkId !== 'none') {
    const activeRouteEvent = new CustomEvent(
      '__custom-event__client-route-make-active',
      { detail: { id: activeLinkId } },
    );
    document.dispatchEvent(activeRouteEvent);
  }
};
